import type { WikiBlock } from "../types";

/** Judgment Selling — 통찰 인앱 요약 (SSOT: trait.insight). */
export const talentInsightBlocks: readonly WikiBlock[] = [
  {
    type: "callout",
    tone: "info",
    text: "전장을 읽고 살아남을 자리를 고릅니다. 명령이 오기 전에도 “여기 서면 살까?”를 봅니다.",
  },
  { type: "h2", text: "플레이에서 보이고 싶은 것" },
  {
    type: "ul",
    items: [
      "통찰 높음 → 안전한 자리 중에서도 힐 닿는 곳·탱커 뒤를 고른다",
      "통찰 낮음 → 복잡하게 안 고르고, 그냥 붙어서 때린다",
      "너무 높으면 → 자리·타이밍을 고민하다 공격 타이밍을 놓친다",
      "직감이 바닥이면 → “자리를 깨고 살기” 자체가 잘 안 열린다",
    ],
  },
  { type: "h2", text: "디자인 의도" },
  {
    type: "ul",
    items: [
      "먼저 “여기는 맞아 죽는 자리인가?”를 가린 다음, 그 안에서 더 안전한 칸을 고른다",
      "재능이 “위험한데도 여기가 좋아”라고 우기면 안 된다. 안전한 칸이 우선이다",
      "“지금 피할까?”는 직감이 연다. 통찰은 “어디로 설까?”다",
      "로스터의 통찰 바 하나만 봐도 “얼마나 멀리 서나 / 여유를 두나”를 짐작할 수 있어야 한다",
    ],
  },
  { type: "h2", text: "높이면 / 낮추면" },
  {
    type: "table",
    headers: ["", "높이면", "낮추면"],
    rows: [
      ["좋은 점", "멀리·안전한 자리 · 여유 있게 선다", "빨리 붙고 단순하게 친다"],
      ["나쁜 점", "표적을 바꾸기 전에 망설인다", "여유 없이 위험한 자리로 들어간다"],
      ["한마디", "자리를 읽는다", "손을 먼저 쓴다"],
    ],
  },
  {
    type: "p",
    text: "스탠드·여유 pad·망설임·생존 tip 게이트 식 → Wiki 「재능 계산식」.",
  },
];
